import React, { useContext, useEffect, useState } from 'react';
import {
    Block,
} from "../../../components/Component";
import { useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
import { Card } from "reactstrap";
import { UserContext } from '../user-manage/UserContext';

const TenantTab = ({match}) => {
    const { contextData } = useContext(UserContext);
    const [data] = contextData;
    const [user, setUser] = useState();
    const location = useLocation();
    useEffect(() => {
        const id = match.params.id;
        if (id !== undefined || null || "") {
            let spUser = data.find((item) => item.id === Number(id));
            setUser(spUser);
        } else {
            setUser(data[0]);
        }
    }, [match.params.id, data]);
    useEffect(() => {

    }, [])
  return (
    <Block>
 <Card className="card-bordered">
        <div className="card-aside-wrap" id="user-detail-block">
            <div className="card-content">
                <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
                    <li className="nav-item">
                        <Link className={
                            `nav-link text-active-primary ` +
                            (location.pathname === `${process.env.PUBLIC_URL}/Tenant/Accounts/TenantConfiguration/${user?.id}` && 'active')
                        }
                            to={`${process.env.PUBLIC_URL}/Tenant/Accounts/TenantConfiguration/${user?.id}`}>
                            <span>General</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className={
                            `nav-link text-active-primary ` +
                            (location.pathname === `${process.env.PUBLIC_URL}/Tenant/Accounts/License` && 'active')
                        }
                            to={`${process.env.PUBLIC_URL}/Tenant/Accounts/License`}>
                            <span>License</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className={
                            `nav-link text-active-primary ` +
                            (location.pathname === `${process.env.PUBLIC_URL}/Tenant/Accounts/Secret` && 'active')
                        }
                            to={`${process.env.PUBLIC_URL}/Tenant/Accounts/Secret`}>
                            <span>Secret</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className={
                            `nav-link text-active-primary ` +
                            (location.pathname === `${process.env.PUBLIC_URL}/Tenant/Accounts/SMTPsetting` && 'active')
                        }
                            to={`${process.env.PUBLIC_URL}/Tenant/Accounts/SMTPsetting`}>
                            <span>SMTP setting</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className={
                            `nav-link text-active-primary ` +
                            (location.pathname === `${process.env.PUBLIC_URL}/Tenant/Accounts/SMSsetting` && 'active')
                        }
                            to={`${process.env.PUBLIC_URL}/Tenant/Accounts/SMSsetting`}>
                            <span>SMS setting</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link className={
                            `nav-link text-active-primary ` +
                            (location.pathname === `${process.env.PUBLIC_URL}/Tenant/Accounts/Settings` && 'active')
                        }
                            to={`${process.env.PUBLIC_URL}/Tenant/Accounts/Settings`}>
                            <span>Settings</span>
                        </Link>
                    </li>
                </ul>

            </div>
        </div>
    </Card>
</Block>
  )
}

export default TenantTab